<template>


    <div v-if="activities">

      <h1>{{ $t('labels.select_activity') }}</h1>

      <div class="actions actions--fixed">
            <div class="action" v-for="activity in activities" :key="activity.id">
                <a
                    href="#"
                    class="action-button action-button--withFigure"
                    :class="currentActivity && currentActivity.activity_id !== activity.id ? 'disabled': ''"
                    @click.prevent="onActivitySelect(activity)"
                    :style="activity.color ? 'background: ' + activity.color: ''"
                >
                    <figure class="action-figure">
                        <img :id="'activity-' + activity.id" :src="getImage(activity)" height="75" width="75" v-if="activity.image_path">
                    </figure>
                    <span v-text="getName(activity)"></span>
                </a>
            </div>
        </div>

        <div class="app-actions">
            <cancel-button clear-activity="1"></cancel-button>

            <button class="btn btn-secondary btn--xl" @click="synchronise" :disabled="!online" v-if="isManager">
                {{ $t('labels.synchronise') }}
            </button>

            <button class="btn btn-secondary btn--xl" @click="startBreak" v-if="currentLocation.manual_breaks">
                <font-awesome-icon :icon="['fas', 'coffee']" /> {{ $t('labels.break') }}
            </button>
        </div>
    </div>
</template>

<script>
import {writeTrackLog} from "../utils/tracking";
import {isOnline} from "@/utils/online";
import CancelButton from "../components/app/CancelButton";
import FileCache from "@/utils/file";

var moment = require('moment');

export default {
  name: 'choose-activity',
  components: {CancelButton},
  computed: {
    online() {
      return this.$store.state.online;
    },

    currentLocation() {
      return this.$store.getters.currentLocation
    },

    currentDevice() {
      return this.$store.getters.currentDevice
    },

    currentEmployee() {
      return this.$store.getters.currentEmployee
    },

    currentWorkday() {
      return this.$store.getters.currentWorkday
    },

    activities() {
      const ordered = this.activityOrder
          ? this.activityOrder.split('|')
          : (this.currentLocation && this.currentLocation.activity_order ? this.currentLocation.activity_order : []);

      if (ordered.length) {
        return this.$store.state.activities
            .filter(activity => ordered.indexOf(activity.id.toString()) > -1)
            .map(activity => {
              activity.order = ordered.indexOf(activity.id.toString())
              return activity
            })
            .sort((a, b) => {
              if (a.order > b.order) return 1;
              if (a.order < b.order) return -1;
              return 0
            });
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        return this.$store.state.activities
            .sort((a, b) => {
              if (a.order > b.order) return 1;
              if (a.order < b.order) return -1;
              return 0
            });
      }

    },

    currentActivity() {
      return this.$store.getters.currentActivityForEmployee
    },

    currentBreak() {
      return this.$store.getters.currentBreakForEmployee
    },

    currentEmployeeActivities() {
      return this.$store.getters.currentEmployeeActivities
    },

    packagings() {
      return this.$store.getters.packagings
    },

    activityOrder() {
      return this.$store.getters.activityOrder
    },

    isManager() {
      if (this.currentLocation && this.currentEmployee) {
        return this.currentLocation.managers.find(manager => manager.id === this.currentEmployee.id);
      }

      return false
    }
  },

  methods: {
    async onActivitySelect(activity) {
      if (this.currentDevice.pre_register_activities) {
        if (!this.currentActivity) {
          if (this.$store.state.enableTracking) writeTrackLog("Select new activity: " + activity.name);

          this.$parent.preRegistering = true;
          activity.preRegistering = true;

          const timesheetEntry = await this.registerNew(activity);

          const route = this.$parent.determineRoute(timesheetEntry);
          if (route !== null && route !== undefined) this.$router.push(route);
          return;
        }

        if (this.currentActivity.activity_id !== activity.id) {
          this.$store.dispatch('setError', 'errors.unfinished_activity');
        } else {
          if (this.$store.state.enableTracking) writeTrackLog("Select current activity: " + activity.name);

          const route = this.$parent.determineRoute(this.currentActivity);
          if (route !== null && route !== undefined) this.$router.push(route);
        }

        return;
      }

      this.$store.commit('syncOnline', false);

      if (!this.currentActivity) {
        if (this.$store.state.enableTracking) writeTrackLog("Select new activity: " + activity.name);
        const newActivity = await this.registerNew(activity);

        const route = this.$parent.determineRoute(newActivity);

        if (route !== null && route !== undefined) return this.$router.push(route);

        return this.$route.name !== 'pin' ? this.$router.push({name: 'pin'}) : null;
      }

      if (this.currentActivity.activity_id !== activity.id) {
        return this.$store.dispatch('setError', 'errors.unfinished_activity');
      }

      if (this.$store.state.enableTracking) writeTrackLog("Select current activity: " + activity.name);

      const route = this.$parent.determineRoute(this.currentActivity);
      if (route !== null && route !== undefined) return this.$router.push(route);
    },

    startBreak() {
      if (this.$store.state.enableTracking) writeTrackLog("Start break");

      if (this.currentActivity) {
        this.$store.dispatch('updateActivity', {id: this.currentActivity.id, 'on_hold': true});
      }

      const payload = {type: 2, activity_id: null};

      this.$store.dispatch('startActivity', payload);

      this.$store.commit('setChecked', {name: 'pin'});
    },

    synchronise() {
      const self = this;
      const unfinished = [];

      window.timesheetStore
          .iterate(activity => {
            if (!activity.end) unfinished.push(activity);
          })
          .then(function () {
            if (unfinished.length) {
              const r = confirm(self.$t('labels.confirm_sync'));

              if (r == true) self.confirmSynchronise();
            } else {
              self.confirmSynchronise();
            }
          })
    },

    confirmSynchronise() {
      if (this.$store.state.enableTracking) writeTrackLog('Synchronise from activities view');
      window.events.$emit('syncLocalToRemote');
    },

    getImage(activity) {
      if (isOnline()) {
        if (activity.image_path !== null && activity.image_path !== undefined) return activity.image_path;
      } else if (activity.image_path !== null)  {
        let parts = activity.image_path.split('/');
        let fileName = parts[parts.length-1];
        FileCache.get(fileName, (fileEntry) => {
          document.getElementById('activity-' + activity.id).src = fileEntry.toURL();
          return fileEntry.fullPath;
        })
      }
    },

    async registerNew(activity) {
      let newActivity = {activity_id: activity.id, type: 1};

      if (activity.preRegistering) newActivity.start = moment().toISOString();

      newActivity = await this.$store.dispatch('registerActivity', newActivity);

      if (this.$store.state.enableTracking) writeTrackLog('Create new activity entry:' + JSON.stringify(newActivity));

      return newActivity;
    },

    getName(activity) {
      const lang = document.documentElement.lang;

      if (activity.translations && activity.translations[lang]) return activity.translations[lang];

      return activity.name
    }
  },

  mounted() {
    window.events.$emit('disableNumpad');
    if (this.$store.state.enableTracking) writeTrackLog("VIEW: Select activity");
    if (this.currentEmployee === null || this.currentEmployee === undefined) return this.$router.push({name: 'pin'});
    if (this.currentBreak) return this.$router.push({name: 'break'});

    if (this.currentActivity && !this.$store.getters.activityById(this.currentActivity.activity_id)) {
      this.$store.dispatch('updateActivity', {
        id: this.currentActivity.id,
        end: new moment().toISOString()
      });
    }
  }
}
</script>
